/**
 * The words the Shop's search actually matches on: ASCII-folded, lowercased,
 * two characters or longer, at most six. Mirrors the Shop's own `searchWords`
 * so this site never fires a request the Shop would answer with nothing.
 */
export function meaningfulSearchWords(input: string): string[] {
  return (
    input
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .match(/[a-z0-9]+/g)
      ?.filter((word) => word.length >= 2)
      .slice(0, 6) ?? []
  )
}

export function hasMeaningfulSearchWords(input: string): boolean {
  return meaningfulSearchWords(input).length > 0
}
